/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Review_LabelInputs */

const en_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

const fr_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revision`)
};

const de_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezension`)
};

const it_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisione`)
};

const ru_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const es_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisar`)
};

const zh_cn2_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`审查`)
};

const ja_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー`)
};

const hi_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समीक्षा`)
};

const pt_pt2_error_nav_review_label = /** @type {(inputs: Error_Nav_Review_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

/**
* | output |
* | --- |
* | "Review" |
*
* @param {Error_Nav_Review_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_review_label = /** @type {((inputs?: Error_Nav_Review_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Review_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_review_label(inputs)
	if (locale === "de") return de_error_nav_review_label(inputs)
	if (locale === "it") return it_error_nav_review_label(inputs)
	if (locale === "ru") return ru_error_nav_review_label(inputs)
	if (locale === "es") return es_error_nav_review_label(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_review_label(inputs)
	if (locale === "ja") return ja_error_nav_review_label(inputs)
	if (locale === "hi") return hi_error_nav_review_label(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_review_label(inputs)
	return en_error_nav_review_label(inputs)
});